import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import Header from "../../Common/Layout/Header";
import SideBar from "../../Common/Layout/Sidebar";
const initialFieldValues = {
    applicationLenderId: "00000000-0000-0000-0000-000000000000",
    lendingApplicationId: "00000000-0000-0000-0000-000000000000",
    lenderId: "00000000-0000-0000-0000-000000000000",
    status: "PENDING",
    amount: 0
};
export default function ApplicationLenderOffers() {
    const [loading, setLoading] = useState(false);
    const [values, setValues] = useState(initialFieldValues);
    const [errors, setErrors] = useState({});
    const [lenders, setLenders] = useState([]);
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken")
        }
    }
    const validate = () => {
        let temp = {};
        temp.imageSrc = values.imageSrc === "" ? false : true;
        setErrors(temp);
        return Object.values(temp).every((x) => x === true);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            setLoading(true);
            const formData = new FormData()
            formData.append("applicationLenderId", values.applicationLenderId)
            formData.append("userId", localStorage.getItem("userId"))
            formData.append("imageFile", values.imageFile)
            addOrEdit(formData);
        }
    }
    const applicationAPI = () => {
        return {
            create: (newrecord) =>
                axios.post(config.APIACTIVATEURL + config.CREATECLIENTDOCUMENT, newrecord, { ...headerconfig })
        };
    };
    const addOrEdit = (formData) => {
        if (formData.get('applicationLenderId') === "00000000-0000-0000-0000-000000000000") {
            applicationAPI()
                .create(formData)
                .then((res) => {
                    if (res.data.statusCode === 200) {
                        handleSuccess("Document Uploaded");
                        resetForm();
                        setLoading(false);
                        GetLenders();
                    }
                    else {
                        handleError(res.data.message);
                        setLoading(false);
                    }
                })
                .catch(function (error) {
                    handleError("Error in saving data");
                    setLoading(false);
                });
        }
    };
    const resetForm = () => {
        setValues(initialFieldValues);
        setErrors({});
    };
    const onDelete = (e, id) => {
        if (window.confirm('Are you sure to delete this record?')) {
            axios.delete(config.APIACTIVATEURL + config.DELETECLIENTDOCUMENT + "/" + id, { ...headerconfig })
                .then((response) => {
                    if (response.data.statusCode === 200) {
                        handleSuccess(response.data.message);
                        GetLenders();
                    }
                    else {
                        handleError(response.data.message);
                        GetLenders();
                    }
                });
        }
    }
    const GetLenders = () => {
        axios
            .get(config.APIACTIVATEURL + config.GETLENDER, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setLenders(response.data.data.data);
                }
            });
    };
    const applyErrorClass = (field) => field in errors && errors[field] === false ? " form-control-danger" : "";
    useEffect(() => {
        GetLenders();
    }, [])
    return (
        <div id="layout-wrapper">
            <Header></Header>
            <SideBar></SideBar>
            <div className="vertical-overlay" />
            <div className="main-content">
                <div className="page-content">
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex align-items-center mb-4">
                                <h5 className="card-title flex-grow-1 mb-0">Lender Offers</h5>
                            </div>
                            <div className="row">
                                <div className="col-4">
                                    <div className="card">
                                        <div className="card-header bg-primary text-white d-flex align-items-center">
                                            <h4 className="card-title text-white mb-0 flex-grow-1">LCF</h4>
                                            <Link className="btn btn-success ms-auto">ACCEPT</Link>
                                        </div>
                                        <div className="card-body">
                                            <ul className="list-group px-0">
                                                <li className="list-group-item d-flex justify-content-between">
                                                    <span>Loan Amount :</span>
                                                    <span>USD 25000</span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between">
                                                    <span>Rate% :</span>
                                                    <span>1.499</span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between">
                                                    <span>Payback Amount :</span>
                                                    <span>USD 44,900.00</span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between">
                                                    <span>Payment Amount :</span>
                                                    <span>USD 374.45</span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between">
                                                    <span>Payment Frequency :</span>
                                                    <span>DAILY</span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between">
                                                    <span>Number of Payments :</span>
                                                    <span>120</span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between">
                                                    <span>Commisssion Points :</span>
                                                    <span>100</span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between">
                                                    <span>Your Commisssion</span>
                                                    <span>USD 1000</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="card">
                                        <div className="card-header bg-primary text-white d-flex align-items-center">
                                            <h4 className="card-title text-white mb-0 flex-grow-1">Mainstreet</h4>
                                            <Link className="btn btn-success ms-auto">ACCEPT</Link>
                                        </div>
                                        <div className="card-body">
                                            <ul className="list-group px-0">
                                                <li className="list-group-item d-flex justify-content-between">
                                                    <span>Loan Amount :</span>
                                                    <span>USD 25000</span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between">
                                                    <span>Rate :</span>
                                                    <span>1.499</span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between">
                                                    <span>Payback Amount :</span>
                                                    <span>USD 44,900.00</span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between">
                                                    <span>Payment Amount :</span>
                                                    <span>USD 374.45</span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between">
                                                    <span>Payment Frequency :</span>
                                                    <span>DAILY</span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between">
                                                    <span>Number of Payments :</span>
                                                    <span>120</span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between">
                                                    <span>Commisssion Points :</span>
                                                    <span>100</span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between">
                                                    <span>Your Commisssion</span>
                                                    <span>USD 1000</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="card">
                                        <div className="card-header bg-primary text-white d-flex align-items-center">
                                            <h4 className="card-title text-white mb-0 flex-grow-1">Global</h4>
                                            <Link className="btn btn-success ms-auto">ACCEPT</Link>
                                        </div>
                                        <div className="card-body">
                                            <ul className="list-group px-0">
                                                <li className="list-group-item d-flex justify-content-between">
                                                    <span>Loan Amount :</span>
                                                    <span>USD 25000</span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between">
                                                    <span>Rate :</span>
                                                    <span>1.499</span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between">
                                                    <span>Payback Amount :</span>
                                                    <span>USD 44,900.00</span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between">
                                                    <span>Payment Amount :</span>
                                                    <span>USD 374.45</span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between">
                                                    <span>Payment Frequency :</span>
                                                    <span>DAILY</span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between">
                                                    <span>Number of Payments :</span>
                                                    <span>120</span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between">
                                                    <span>Commisssion Points :</span>
                                                    <span>100</span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between">
                                                    <span>Your Commisssion</span>
                                                    <span>USD 1000</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}